import { array, object } from "yup";

export const DEFAULT_VALUES = {
  paymentMethods: [],
};

export const VALIDATION_SCHEMA = object().shape({
  paymentMethods: array().of(
    object().shape({
      paymentMethod: object().required("Harus diisi"),
      outletChartOfAccount: object().required("Harus diisi"),
    }),
  ),
});
